import { handleActions } from "redux-actions";

import {
	getJudgeSettingsAsyncAction,
	postSettingsAsyncAction,
	getQuestionsListAsyncAction,
	deleteQuestionsByIdAsyncAction,
	getQuestionAsyncAction,
	updateQuestionAsyncAction,
	postQuestionAsyncAction,
	getJudgeProfileListAsyncAction,
	getJudgeProfileAsyncAction,
	updateJudgeProfileAsyncAction,
	resetAction,
} from "./judgeActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	settings: defaultAjaxState,
	profile_list: defaultAjaxState,
	questions_list: defaultAjaxState,
	post_settings: defaultAjaxState,
	question_detail: defaultAjaxState,
	delete_questions_byid: defaultAjaxState,
	update_question: defaultAjaxState,
	post_question: defaultAjaxState,
	profile_detail: defaultAjaxState,
	update_profile: defaultAjaxState,
};

export const judgeReducer = handleActions(
	new Map([
		// get settings
		[
			getJudgeSettingsAsyncAction.request,
			(state, { payload }) => ({
				...state,
				settings: {
					...initialState.settings,
					loading: true,
				},
			}),
		],
		[
			getJudgeSettingsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				settings: {
					...initialState.settings,
					response: payload,
				},
			}),
		],
		[
			getJudgeSettingsAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				settings: {
					...initialState.settings,
					error: payload,
				},
			}),
		],

		// post settings
		[
			postSettingsAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_settings: {
					...initialState.post_settings,
					loading: true,
				},
			}),
		],
		[
			postSettingsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_settings: {
					...initialState.post_settings,
					response: payload,
				},
			}),
		],
		[
			postSettingsAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_settings: {
					...initialState.post_settings,
					error: payload,
				},
			}),
		],

		// get profile list
		[
			getJudgeProfileListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				profile_list: {
					...initialState.profile_list,
					loading: true,
				},
			}),
		],
		[
			getJudgeProfileListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				profile_list: {
					...initialState.profile_list,
					response: payload,
				},
			}),
		],
		[
			getJudgeProfileListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				profile_list: {
					...initialState.profile_list,
					error: payload,
				},
			}),
		],

		// update question
		[
			updateJudgeProfileAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_profile: {
					...initialState.update_profile,
					loading: true,
				},
			}),
		],
		[
			updateJudgeProfileAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_profile: {
					...initialState.update_profile,
					response: payload,
				},
			}),
		],
		[
			updateJudgeProfileAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_profile: {
					...initialState.update_profile,
					error: payload,
				},
			}),
		],

		// get questions list
		[
			getQuestionsListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				questions_list: {
					...initialState.questions_list,
					loading: true,
				},
			}),
		],
		[
			getQuestionsListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				questions_list: {
					...initialState.questions_list,
					response: payload,
				},
			}),
		],
		[
			getQuestionsListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				questions_list: {
					...initialState.questions_list,
					error: payload,
				},
			}),
		],

		// get question detail
		[
			getQuestionAsyncAction.request,
			(state, { payload }) => ({
				...state,
				question_detail: {
					...initialState.question_detail,
					loading: true,
				},
			}),
		],
		[
			getQuestionAsyncAction.success,
			(state, { payload }) => ({
				...state,
				question_detail: {
					...initialState.question_detail,
					response: payload,
				},
			}),
		],
		[
			getQuestionAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				question_detail: {
					...initialState.question_detail,
					error: payload,
				},
			}),
		],

		// get profile detail
		[
			getJudgeProfileAsyncAction.request,
			(state, { payload }) => ({
				...state,
				profile_detail: {
					...initialState.profile_detail,
					loading: true,
				},
			}),
		],
		[
			getJudgeProfileAsyncAction.success,
			(state, { payload }) => ({
				...state,
				profile_detail: {
					...initialState.profile_detail,
					response: payload,
				},
			}),
		],
		[
			getJudgeProfileAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				profile_detail: {
					...initialState.profile_detail,
					error: payload,
				},
			}),
		],

		// post question
		[
			postQuestionAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_question: {
					...initialState.post_question,
					loading: true,
				},
			}),
		],
		[
			postQuestionAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_question: {
					...initialState.post_question,
					response: payload,
				},
			}),
		],
		[
			postQuestionAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_question: {
					...initialState.post_question,
					error: payload,
				},
			}),
		],

		// update question
		[
			updateQuestionAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_question: {
					...initialState.update_question,
					loading: true,
				},
			}),
		],
		[
			updateQuestionAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_question: {
					...initialState.update_question,
					response: payload,
				},
			}),
		],
		[
			updateQuestionAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_question: {
					...initialState.update_question,
					error: payload,
				},
			}),
		],

		// delete questions by id
		[
			deleteQuestionsByIdAsyncAction.request,
			(state, { payload }) => ({
				...state,
				delete_questions_byid: {
					...initialState.delete_questions_byid,
					loading: true,
				},
			}),
		],
		[
			deleteQuestionsByIdAsyncAction.success,
			(state, { payload }) => ({
				...state,
				delete_questions_byid: {
					...initialState.delete_questions_byid,
					response: payload,
				},
			}),
		],
		[
			deleteQuestionsByIdAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				delete_questions_byid: {
					...initialState.delete_questions_byid,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
